import { Navigate } from "react-router-dom";
import { Show } from "@clerk/react";

export const Protected = ({ children }) => (
  <>
    <Show when="signed-in">{children}</Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
  </>
);
